import React from 'react';
import { useContext ,useState ,useEffect}from 'react';
import {
  Button,
  DataGrid,
  InputGrid,
  QuantaForm ,
  QuantaFormik,
  useQuantaFormikContext,
  Text,
  useResponsiveParams,
  QuantaInput ,
  MixedGridGroup,
  NotificationList
} from 'quanta-ui';
import { GET_TWO_WHEELER_POLICY_VAR_DETAILS } from '../../queries';
import { useQuery } from '@apollo/client';
import {Loading} from 'quanta-flows/modules/layout';
import {Error} from 'quanta-flows/modules/layout';
// import { updateMotorQuote } from '../../_graphql/state';
import { updateMotorQuote } from 'quanta-flows/modules/quote/motor/state';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft,faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { QuantaConfigContext } from 'quanta-flows';
import { CurrencyFormater } from 'quanta-flows';
import { useFetchQuery } from 'quanta-flows';

export default function QuoteData({ 
  goToStep, 
  productCode,
  productName,
  lobCode,
  lobName,
  quoteNumber,
  IDVRef,
  idvValues,
  setshowCalculatePremiumButtonIDV,
  showCalculatePremiumButtonIDV,
  updatedidvvalues,
  modify,
  irflimitvalue,
  dataRole,
  imdcode,
  ...props
}) {
  const fetchQuery = useFetchQuery();
  const [alerts, setAlerts] = useState([]);
  let repeatForMobile = 1;
  let repeatForDesktop = 3;
  let repeatforIDV=2;
  let repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop,
  });

  let {
    loading,
    error,
    data: state,
  } = useQuery(GET_TWO_WHEELER_POLICY_VAR_DETAILS,{
    fetchPolicy: 'cache-first',
  });
 
  if (loading) return <Loading />;
  if (error) return <Error error={error} />;
   const { branding } = useContext(QuantaConfigContext);
  let { motorQuote } = state;
  let data = [
    {
      label: 'Vehicle Details (Make, Model, Variant, Fuel Type, Cubic Capacity,Vehicle Segment)',
      colSpan: 2,
      text: (
        <Text>
          {[
            motorQuote?.make?.value?.trim(),
            motorQuote?.model?.value?.trim(),
            motorQuote?.variant?.value?.trim(),
            motorQuote?.fuelType,
            motorQuote?.cubeCapacity,
            motorQuote?.segmentType
          ]
            .filter((a) => a)
            .join(', ') ? (
            [
              motorQuote?.make?.value?.trim(),
              motorQuote?.model?.value?.trim(),
              motorQuote?.variant?.value?.trim(),
              motorQuote?.fuelType,
              motorQuote?.cubeCapacity,
              motorQuote?.segmentType
            ]
              .filter((a) => a)
              .join(', ')
          ) : (
            <Text severity="neutral">{'Not Captured'}</Text>
          )}
        </Text>
      ),
    },
    {
      label: 'Date of Registration/Purchase',
      className: repeat === repeatForMobile?'':'ml-2',
      text: (
        <Text>
          {[
            motorQuote?.dateOfReg?.trim(),
            motorQuote?.rtoAuthorityCode?.trim(),
            motorQuote?.rtoLocationDesc,
          ]
            .filter((a) => a)
            .join(', ') ? (
            [
              motorQuote?.dateOfReg?.trim(),
              motorQuote?.rtoAuthorityCode?.trim(),
              motorQuote?.rtoLocationDesc,
            ]
              .filter((a) => a)
              .join(', ')
          ) : (
            <Text severity="neutral">{'Not Captured'}</Text>
          )}
        </Text>
      ),
    },
    {
      label: 'Previous Insurance',
      colSpan: 2,
      text: (
        <Text>
          {[
            motorQuote?.policyCoverType?.trim(),
            motorQuote?.policyExpiryDate?.trim(),
            motorQuote?.previousYearNCBSlab,
          ]
            .filter((a) => a)
            .join(', ') ? (
            [
              motorQuote?.policyCoverType?.trim(),
              motorQuote?.policyExpiryDate?.trim(),
              motorQuote?.previousYearNCBSlab,
            ]
              .filter((a) => a)
              .join(', ')
          ) : (
            <Text severity="neutral">
              {motorQuote?.businessType?.toLowerCase() ===
              'new business'
                ? 'NA'
                : 'Not Captured'}
            </Text>
          )}
          {motorQuote?.previousYearNCBSlab ? '%' : null}
        </Text>
      ),
    },
    {
      label: ``,
      className: repeat === repeatForMobile?'':'ml-2',
      text: (
        <div className="flex flex-col items-baseline h-full">
          {!motorQuote?.quotationNo &&
          <Button
            flat={true}
            className="md:w-48"
            disabled={
              props?.forwardedCoversFormRef?.current?.values
                ?.isQuoteSaving ||
              props?.forwardedCoversFormRef?.current?.values
                ?.isQuoteSaved ||
              props?.forwardedCoversFormRef?.current?.values
                ?.isPremiumLoading
            }
            onClick={(e) => {
              goToStep(0);
              updateMotorQuote({
                ...motorQuote,
                currentTab: 'vehicle',
                isPremiumCalculating: null,
              });
            }}
            iconPre={<FontAwesomeIcon icon={faChevronLeft} className={repeat === repeatForMobile?'mr-2':''}/>}
          >
            Change
          </Button>}
          {motorQuote?.quotationNo &&
            <Button
              flat={true}
              className="md:w-48"
              onClick={(e) => {
                goToStep(0);
              }}
              iconPre={<FontAwesomeIcon icon={faChevronLeft} className={`-ml-1 ${repeat === repeatForMobile?'mr-2':''}`}/>}
            >
              View Vehicle Details
            </Button>
          }
        </div>
      ),
    },
    productCode?.toString()!=='3176'||
    motorQuote?.productVariant?.toLowerCase()?.search('liability') === -1
    || motorQuote?.productType?.toLowerCase()?.search('liability') === -1
    ?
    {
      label: 'First Year Insured Declared Value(IDV)',
      colSpan: 2,
      text: /*{
        <CountAnimation
         end={parseFloat(
           premiumData?.calculatePremiumQuoteCarSecure?.idv1,
         )}
         duration={1}
         decimals={2}
         prefix={branding.currency + ' '}
         formattingFn={(num) => {
           return Parse(num, true, false, branding, true);
         }}
       /> 
     }*/ 
     motorQuote?. premiumData?.idv1 !==
    null &&
    motorQuote?. premiumData?.idv1  !==
    undefined &&
    motorQuote?. premiumData?.idv1  !== ''
    ?`${CurrencyFormater(
     parseFloat(
        motorQuote?. premiumData?.idv1,
     ),
     true,
     false,
     branding,
     true,
   )}`
   :'Not Captured',
    }:null,

    motorQuote?. premiumData?.vehicleAge !==
    null &&
    motorQuote?. premiumData?.vehicleAge  !==
    undefined &&
    motorQuote?. premiumData?.vehicleAge  !== ''
    ? {
      label: 'Vehicle Age',
      text: 
      `${motorQuote?. premiumData?.vehicleAge} year(s)`,
    }
    : {
      label: 'Vehicle Age',
      text: 
      `Not Captured`,
    },
  ].filter((a) => a)
  

  const validate =(values) =>{
  
    const errors = {};
    let errorCount=0;
   
 if (productCode?.toString() !== '3176') {
  if(parseFloat(values?.adjustmentIRF2)!==0 && !values?.IRF2comments){
    errors.IRF2comments='* IRF2 Comments section is mandatory when value in IRF2 Basic OD is other than 0';
    // errorCount += 1;
  }
    if (
      values?.changedIDV === '' ||
      values?.changedIDV === null ||
      values?.changedIDV === undefined
    ) {
      errors.changedIDV = '* Required';
      // errorCount += 1;
    }
    if (values?.changedIDV) {
      if (
        idvValues?.insuredDeclaredValue?.minSuggestedIDV &&
        parseFloat(values?.changedIDV) <
        parseFloat(idvValues?.insuredDeclaredValue?.minSuggestedIDV)
      ) {
        // errorCount += 1;
        errors.changedIDV = `* Changed IDV can't be less than ${idvValues?.insuredDeclaredValue?.idvPctMin}% of suggested IDV`;
      }
      if (
        idvValues?.insuredDeclaredValue?.maxSuggestedIDV &&
        parseFloat(values?.changedIDV) >
        parseFloat(idvValues?.insuredDeclaredValue?.maxSuggestedIDV)
      ) {
        // errorCount += 1;
        errors.changedIDV = `* Changed IDV can't be greater than ${idvValues?.insuredDeclaredValue?.idvPctMax}% of suggested IDV`;
      }
    }
    if (
      values?.adjustmentIRF === '' ||
      values?.adjustmentIRF === null ||
      values?.adjustmentIRF === undefined
    ) {
      // errorCount += 1;
      errors.adjustmentIRF = '* Required';
    }
    if (
      values?.adjustmentIRF &&
      parseFloat(values?.adjustmentIRF) < -parseFloat(idvValues?.insuredDeclaredValue?.irfPctMin)
    ) {
      errors.adjustmentIRF = `* IRF can't be less than -${idvValues?.insuredDeclaredValue?.irfPctMin}%`;
    }
    if (
      values?.adjustmentIRF &&
      parseFloat(values?.adjustmentIRF) > parseFloat(idvValues?.insuredDeclaredValue?.irfPctMax)
    ) {
      errors.adjustmentIRF = `* IRF can't be more than ${idvValues?.insuredDeclaredValue?.irfPctMax}%`;
      }
    }
    if (
      values?.adjustmentIRF2 &&
      parseFloat(values?.adjustmentIRF2) < -parseFloat(idvValues?.insuredDeclaredValue?.irf2PctMin)
    ) {
      errors.adjustmentIRF2 = `* IRF2 Basic OD can't be less than -${idvValues?.insuredDeclaredValue?.irf2PctMin}%`;
    }
    if (
      values?.adjustmentIRF2 &&
      parseFloat(values?.adjustmentIRF2) > parseFloat(idvValues?.insuredDeclaredValue?.irf2PctMax)
    ) {
      errors.adjustmentIRF2 = `*  IRF2 Basic OD can't be more than ${idvValues?.insuredDeclaredValue?.irf2PctMax}%`;
      }
    
  //  if (errorCount==0){
  //   errors={}
  //  }
    updatedidvvalues.current.errors = errors;
    if(Object.keys(errors)?.length>0){
      errorCount += 1;
    }
    else{
   errorCount=0
    }
    updatedidvvalues.current.errors = errorCount;

    return errors
  }
  const IDVForm = ({validate}) =>{
    const { values, setFieldValue, resetForm } =
    useQuantaFormikContext();
    
    updatedidvvalues.current = values;
    let irfrolelimitvalue
    irflimitvalue?.IRF2_Allowed_Limits?.irf2_Role_Limit?.find((e)=>{
    
      if( e?.toLowerCase()===dataRole?.toLowerCase()) {
        irfrolelimitvalue =true
      } 
    })
    let irfimdlimitvalue
    irflimitvalue?.IRF2_Allowed_Limits?.IRF2_Allowed_IMD?.find((e)=>{
  
      if( e?.toString()?.toLowerCase()===imdcode?.toString()?.toLowerCase()) {
        irfimdlimitvalue =true
      } 
    })
    let grid_data = [
      productCode?.toString()!=='3176'||
      motorQuote?.productVariant?.toLowerCase()?.search('liability') === -1
      ?
      {
        title: 'Insured Declared Value',
      grid_data: [
        {
          type: 'render',
          name: 'suggestedIDV',
          component: () => (
            <div className="flex flex-col mt-3">
              <Text type="label">Suggested IDV</Text>
              <span>
                {idvValues?.insuredDeclaredValue?.suggestedIDV||motorQuote?.suggestedIDV? (
                  CurrencyFormater(
                    parseFloat(

                      idvValues?.insuredDeclaredValue?.suggestedIDV
                      ?idvValues?.insuredDeclaredValue?.suggestedIDV
                      :motorQuote?.suggestedIDV,
                    ),
                    true,
                    false,
                    branding,
                  )
                ) : (
                  <Text className="text-neutral-dark">Not Captured</Text>
                )}
              </span>
              {/* <span>
                <Text severity="error" type="label">
                   {errorIDVValues} 
                </Text>
              </span> */}
            </div>
          ),
        },
        {
          type: 'render',
          component: () => (
            <div className="flex flex-col space-y-2">
              <div>
                <QuantaInput
                  type={'number'}
                  size={'large'}
                  label={
                    <>
                      Changed IDV <Text severity="error"></Text>
                    </>
                  }
                  name={'changedIDV'}
                  className={`${
                   
                    (motorQuote?.quotationNo !== '' && !motorQuote?.isProposalModify)
                      ? 'border-neutral-dark'
                      : ''
                  }`}
                  iconPre={
                    <Text
                      severity={
                       
                        (motorQuote?.quotationNo !== '' && !motorQuote?.isProposalModify)
                          ? 'neutral'
                          : 'info'
                      }
                    >
                      {`%`}
                    </Text>
                  }
                  disabled={
                    motorQuote?.quotationNo && !motorQuote?.isProposalModify
                    // motorQuote?.quotationNo === '' ?false:true 
                  }
                  noerror={
                    values?.changedIDV !== '' &&
                    idvValues?.insuredDeclaredValue?.minSuggestedIDV !== '' &&
                    idvValues?.insuredDeclaredValue?.minSuggestedIDV !== ''
                      ? parseFloat(values?.changedIDV) >=
                          parseFloat(idvValues?.insuredDeclaredValue?.minSuggestedIDV) &&
                        parseFloat(values?.changedIDV) <=
                          parseFloat(idvValues?.insuredDeclaredValue?.maxSuggestedIDV)
                      : false
                  }
                  enableSlider={
                    motorQuote?.quotationNo === '' ? true : false ||
                    motorQuote?.isProposalModify
                  }
                  sliderMin={
                    idvValues?.insuredDeclaredValue?.minSuggestedIDV !==
                      undefined &&
                    idvValues?.insuredDeclaredValue?.minSuggestedIDV !==
                      null
                      ? parseFloat(
                          idvValues?.insuredDeclaredValue
                            ?.minSuggestedIDV,
                        )
                      : 0
                  }
                  sliderMax={
                    idvValues?.insuredDeclaredValue?.maxSuggestedIDV !==
                      undefined &&
                    idvValues?.insuredDeclaredValue?.maxSuggestedIDV !==
                      null
                      ? parseFloat(
                          idvValues?.insuredDeclaredValue
                            ?.maxSuggestedIDV,
                        )
                      : 0
                  }
                  sliderStep={1}
                  value={
                    values?.changedIDV!=0
                      ? Math.round(parseFloat(values?.changedIDV))
                      : Math.round(parseFloat(values?.suggestedIDV))
                  }
                  initialValue={
                    values?.changedIDV!=0
                    ?Math.round(parseFloat(values?.changedIDV))
                    
                      : Math.round(parseFloat(idvValues?.insuredDeclaredValue?.suggestedIDV))
                      // : null
                  }
                   onSlide={ (val) => {
                    setFieldValue('changedIDV',Math.round(val))
                    setshowCalculatePremiumButtonIDV(true)
                  }}
                  onDataChange={ (val, _) => {
                    
                    setshowCalculatePremiumButtonIDV(true)
                  }}
                  onKeyDown={ (evt) => {
                    if (
                      (evt?.target?.value?.toString()?.endsWith(' ') &&
                        evt?.key === ' ') ||
                      (evt?.target?.value?.toString()?.length === 0 &&
                        evt?.key === ' ')
                    ) {
                      evt.preventDefault();
                    }
                  }}
                 
                />
              </div>
             {idvValues?.insuredDeclaredValue?.idvPctMax &&
            idvValues?.insuredDeclaredValue?.idvPctMin &&
            (!values?.quotationNo || motorQuote?.isProposalModify)
            && (
              <Text
                severity={'info'}
                type={'normal'}
                className={'w-200'}
              >
                <span>
                  <FontAwesomeIcon icon={faInfoCircle} />
                </span>
                <span>
                  You can choose maximum of {''}{idvValues?.insuredDeclaredValue?.idvPctMax} %  ({branding.currency} {idvValues?.insuredDeclaredValue?.maxSuggestedIDV.toFixed(0)}) and minimum  {idvValues?.insuredDeclaredValue?.idvPctMin} %  {' '}({branding.currency} { 
                 idvValues?.insuredDeclaredValue?.minSuggestedIDV.toFixed(0)} )deviation from the suggested IDV
                </span>
              </Text>
            )}
            </div>
          ),
        },
     
    ].filter((d) => d),
    
  }:null,
  productCode?.toString()!=='3176'||
  motorQuote?.productVariant?.toLowerCase()?.search('liability') === -1
  ?
  {
    title: 'Market Discount',
  grid_data: [
  {
    type: 'render',
    component: () => (
      <div className="flex flex-col space-y-2">
        <div>
          <QuantaInput
            type={'text'}
            size={'large'}
            label={
              <>
                IRF 1 <Text severity="error"></Text>
              </>
            }
            name={'adjustmentIRF'}
            className={`${
             
              (motorQuote?.quotationNo !== '' && !motorQuote?.isProposalModify)
                ? 'border-neutral-dark'
                : ''
            }`}
            iconPre={
              <Text
                severity={
                 
                  (motorQuote?.quotationNo !== '' && !motorQuote?.isProposalModify)
                    ? 'neutral'
                    : 'info'
                }
              >
                {`%`}
              </Text>
            }
            disabled={
              motorQuote?.quotationNo && !motorQuote?.isProposalModify
            }
            onDataChange = { (val, _) => {
               setshowCalculatePremiumButtonIDV(true)
             
            }
            
          }
          onKeyDown={ (evt) => {
            if (
              (evt?.target?.value?.toString()?.endsWith(' ') &&
                evt?.key === ' ') ||
              (evt?.target?.value?.toString()?.length === 0 &&
                evt?.key === ' ')
            ) {
              evt.preventDefault();
            }
          }}
          />
        </div>
      </div>
    ),
  },
  irfrolelimitvalue&&irfimdlimitvalue&&
  {
    type: 'render',
    component: () => (
      <div className="flex flex-col space-y-2">
        <div>
          <QuantaInput
            type={'number'}
            size={'large'}
            label={
              <>
                IRF2 Basic OD   <Text severity="error"></Text>
              </>
            }
            name={'adjustmentIRF2'}
            className={`${
             
              (motorQuote?.quotationNo !== '' && !motorQuote?.isProposalModify)
                ? 'border-neutral-dark'
                : ''
            }`}
            disabled={
              motorQuote?.quotationNo && !modify
            }
            onDataChange = { (val, _) => {
          
               setshowCalculatePremiumButtonIDV(true)

            }
            }
            onKeyDown={ (evt) => {
              if (
                (evt?.target?.value?.toString()?.endsWith(' ') &&
                  evt?.key === ' ') ||
                (evt?.target?.value?.toString()?.length === 0 &&
                  evt?.key === ' ')
              ) {
                evt.preventDefault();
              }
            }}
          />
        </div>
      </div>
    ),
  },
  irfrolelimitvalue&&irfimdlimitvalue&&
  {
    type: 'render',
    component: () => (
      <div className="flex flex-col space-y-2">
        <div>
          <QuantaInput
            type={'text'}
            size={'large'}
            label={
              <>
                IRF2 Comments   <Text severity="error"></Text>
              </>
            }
            name={'IRF2comments'}
            className={`${
             
              (motorQuote?.quotationNo !== '' && !motorQuote?.isProposalModify)
                ? 'border-neutral-dark'
                : ''
            }`}
            disabled={
              motorQuote?.quotationNo && !modify
            }
            onDataChange = { (val, _) => {
             
               setshowCalculatePremiumButtonIDV(true)

            }
            }
            onKeyDown={ (evt) => {
              if (
                (evt?.target?.value?.toString()?.endsWith(' ') &&
                  evt?.key === ' ') ||
                (evt?.target?.value?.toString()?.length === 0 &&
                  evt?.key === ' ')
              ) {
                evt.preventDefault();
              }
            }}
          />
        </div>
      </div>
    ),
  },
].filter((d) => d),
}:null,


].filter((d) => d);

const other_props = {
  flow: 'cols',
  repeat,
  gapX: 6,
  gapY: 0,
  spaceY: 2,
  size: 'full',
  titleSeverity: 'info',
  // useExpandablePaper:true
};
const other_propsidv = {
  flow: 'cols',
  repeatforIDV,
  gapX: 6,
  gapY: 0,
  spaceY: 2,
  size: 'full',
  titleSeverity: 'info',
  // useExpandablePaper:true
};
    return (
      <>
      <QuantaForm>
            <>
             <MixedGridGroup {...{data:grid_data, ...other_propsidv }} />
             </>
        </QuantaForm>
      </>
    )
  }
  const initialValues ={
    adjustmentIRF:motorQuote?.adjustmentIRF, 
    changedIDV: motorQuote?.quotationNo!==''?motorQuote?.changedIDV
   : parseFloat(motorQuote?.suggestedIDV)!=parseFloat(idvValues?.insuredDeclaredValue?.suggestedIDV)
    ?idvValues?.insuredDeclaredValue?.suggestedIDV
    :motorQuote?.changedIDV!==''
    ?motorQuote?.changedIDV
    :idvValues?.insuredDeclaredValue?.suggestedIDV,
  suggestedIDV:idvValues?.insuredDeclaredValue?.suggestedIDV
    ?idvValues?.insuredDeclaredValue?.suggestedIDV
    :motorQuote?.suggestedIDV,
    minSuggestedIDV:motorQuote?.minSuggestedIDV,
    maxSuggestedIDV:motorQuote?.maxSuggestedIDV,    
    irfPctMin:motorQuote?.irfPctMin,
    irfPctMax:motorQuote?.irfPctMax,
    idvPctMin:motorQuote?.idvPctMin,
    idvPctMax:motorQuote?.idvPctMax,
    adjustmentIRF2:motorQuote?.adjustmentIRF2?motorQuote?.adjustmentIRF2:0,
    IRF2comments:motorQuote?.IRF2comments,
  }
  return (
    <>
    <div>
       <NotificationList {...{ items: alerts }} />
                </div>
      <QuantaFormik 
       innerRef={IDVRef}
       {...{ initialValues, validate }}
      >
        
        <>
        <DataGrid
          gap={2}
          gapY={6}
          repeat={repeat}
          data={data}
          textType="normal"
          nullData={() => {
            return (
              <Text type="normal" severity="neutral">
                Not Captured
              </Text>
            );
          }}
        />
        <IDVForm
         {...{ validate }} />

        </>
       
      </QuantaFormik>
      
    </>
   
  );
}
